import TrovaServizioPage from "./TrovaServizioPage";
import { TROVA_PERSONALE_CONFIG } from "../components/trova/servizioConfigs";

export default function TrovaPersonale() {
  return <TrovaServizioPage config={TROVA_PERSONALE_CONFIG} />;
}
